import brandOne from '../assets/images/brand1.png';
import brandTwo from '../assets/images/brand2.png';
import brandThree from '../assets/images/brand3.png';
import brandFour from '../assets/images/brand4.png';
import brandFive from '../assets/images/brand5.png';
import brandSix from '../assets/images/brand6.png';
import brandSeven from '../assets/images/brand7.png';
export const images = [brandOne, brandTwo, brandThree, brandFour, brandFive, brandSix, brandSeven];
